import React, { useEffect, useState } from 'react';
import { Button, ColumnProps, Table, Widget } from '@digital/ui';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { SolicitacaoNaoPrevisto, deleteSolicitacaoNaoPrevisto, listarSolicitacoesNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import { EStatusSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';
import ModalReabrirFinalizarSolicitacao from './Modals/ModalReabrirFinalizarSolicitacao';

interface Props {

}

const WidgetSolicitacoes: React.FC<Props> = ({ }) => {
    const [solicitacoes, setSolicitacoes] = useState<SolicitacaoNaoPrevisto[]>([])

    const handleGetSolicitacoes = () => {
        listarSolicitacoesNaoPrevisto().then((result) => {
            if (result) {
                setSolicitacoes(result)
            }
        })
    }

    const handleDelete = (id: string) => {
        deleteSolicitacaoNaoPrevisto(id).then(() => {
            handleGetSolicitacoes()
        })
    }

    const columns = () => {
        let tempColumns: ColumnProps<SolicitacaoNaoPrevisto>[] = []

        tempColumns.push({
            title: 'Cod. Solicitação',
            dataIndex: 'codigoSolicitacaoTexto',
            ...mountFormFilterDropDown('codigoSolicitacaoTexto', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Tipo',
            dataIndex: 'tipo',
            ...mountFormFilterDropDown('tipo', 'Pesquisar')
        })

        tempColumns.push({
            title: "Data de Abertura",
            dataIndex: 'dataAbertura',
            ...mountFormFilterDropDown('dataAbertura', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Cod. Não Previsto',
            dataIndex: 'codigoNaoPrevistoTexto',
            ...mountFormFilterDropDown('codigoNaoPrevistoTexto', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Nome do Projeto',
            dataIndex: 'nomeProjeto',
            ...mountFormFilterDropDown('nomeProjeto', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Status',
            dataIndex: 'status',
            ...mountFormFilterDropDown('status', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Data do Último Status',
            dataIndex: 'dataUltimoStatus',
            ...mountFormFilterDropDown('dataUltimoStatus', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Total R$',
            dataIndex: 'total',
            ...mountFormFilterDropDown('total', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Solicitante',
            dataIndex: 'nomeSolicitante',
            ...mountFormFilterDropDown('nomeSolicitante', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Responsável',
            dataIndex: 'nomeResponsavel',
            ...mountFormFilterDropDown('nomeResponsavel', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Diretoria',
            dataIndex: 'diretoriaResponsavel',
            ...mountFormFilterDropDown('diretoriaResponsavel', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Área',
            dataIndex: 'areaResponsavel',
            ...mountFormFilterDropDown('areaResponsavel', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Departamento',
            dataIndex: 'departamentoResponsavel',
            ...mountFormFilterDropDown('departamentoResponsavel', 'Pesquisar')
        })

        tempColumns.push({
            title: 'Ações',
            dataIndex: '',
            render: (row: SolicitacaoNaoPrevisto) => {
                return (
                    <>
                        {row.reabrir ?
                            (
                                <ModalReabrirFinalizarSolicitacao
                                    justificativa={row.justificativaReprovacao}
                                    responsavel={row.reprovador}
                                    statusId={row.statusId}
                                    statusAprovacaoId={row.statusAprovacaoId}
                                    id={row.id}
                                />
                            ) : (
                                <Button
                                    id="mrn-btn-visualizar-solicitacao"
                                    type="link"
                                    icon="arrows-circled_up_right_2"
                                    onClick={() => {
                                        window.open(`/naoPrevisto/solicitacao/${row.id}`)
                                    }}
                                />
                            )}
                        {row.canDelete && (
                            <Button
                                id="mrn-btn-excluir-solicitacao"
                                type="link"
                                icon="commons-trash"
                                confirm="Deseja realmente excluir este registro?"
                                okText='Sim'
                                cancelText='Não'
                                onClick={() => {
                                    handleDelete(row.id)
                                }}
                            />
                        )}
                    </>
                )
            }
        })

        return tempColumns
    }

    useEffect(() => {
        handleGetSolicitacoes()
    }, [])

    return (
        <Widget
            title="Solicitações"
            actions={[
                <>
                    <Button
                        id="mrn-btn-criar-solicitacao"
                        title="Criar Solicitação"
                        type="primary"
                        icon="commons-plus"
                        onClick={() => {
                            window.open('/naoPrevisto/solicitacao/new')
                        }}
                    />
                </>
            ]}
        >
            <Table
                columns={columns()}
                dataSource={solicitacoes}
                pagination={false}
                rowKey="id"
            />
        </Widget>
    );
};

export default WidgetSolicitacoes;
